// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js_chunk." + chunkId + "." + "05ef8a16c75932d03434" + ".min.js";
};